<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Division 7</h1>
                    <h2>Thermal & Moisture</h2>
                </div>
                <p>
                    When installing thermal and moisture protection, we pay close attention to achieving the most effective outcome by making sure all joints are properly sealed with the product that is specified. Mold and mildew prevention are essential to all commercial projects. 
                </p>
                <p>
                    Glass fiber acoustical blanket insulation is often necessary for facilities and buildings that need to reduce sound transmission through each wall. Glass fiber helps to increase the STC (Sound Transmission Class) rating per wall system and increase the R-value per wall as well. We utilize rigid foam insulation and metal z-furring to create a high R-value as well as a backer for metal wall panels or other exterior finishes. See what services PC Haines offers for thermal and moisture protection below. 
                </p>
            </div>
            <div class="circles services-circles">
                <pc-services-circles></pc-services-circles>
            </div>
        </div>
    </div>
</div>

<div class="secondary-content-section dark-section">
    <div class="site-gutter">
        <div class="card-container">
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">1</span>
                            <h3>Cladding Support Systems</h3>
                        </div>
                    </div>
                    <p>Exterior wall cladding systems are protective layers added to a buildings outside walls. They offer weather resistance, insulation, proper alignment, ventilation, and load distribution, contributing to the system's overall performance and longevity. This product goes on after a “weather barrier” or “self-adhering sheet barrier” is installed to the exterior plywood or gypsum sheathing. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">2</span>
                            <h3>Thermal Insulation</h3>
                        </div>
                    </div>
                    <p>Thermal insulation reduces heat transfer, keeping buildings warm in winter, cool in summer, and saving energy. It promotes comfort and efficiency. Thermal insulation's value lies in reducing energy consumption, lowering utility costs, and enhancing indoor comfort. It also contributes to environmental sustainability by reducing greenhouse gas emissions. This product is installed in between exterior & interior metal wall & ceiling framing.</p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">3</span>
                            <h3>Weather Barriers</h3>
                        </div>
                    </div>
                    <p>Weather barriers attach to the exterior sheathing or framing of a building. The purpose is to block moisture from passing through walls, floors, and ceilings, preventing mold growth and rot within building cavities. This product is fastened to exterior plywood or gypsum sheathing. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">4</span>
                            <h3>Self-Adhering Air Barriers</h3>
                        </div>
                    </div>
                    <p>Self-adhering sheet air barriers are used in construction to control air leakage, enhancing energy efficiency, moisture management, and indoor air quality. They stick directly to the substrate, creating a continuous barrier against drafts and water intrusion. This product is adhered to exterior plywood or gypsum sheathing.</p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">5</span>
                            <h3>Metal Soffit Panels</h3>
                        </div>
                    </div>
                    <p>Metal soffit panels are pre-finished, low-maintenance panels used for the underside of eaves or overhangs, providing a clean, finished look and ventilation. This product is installed when all exterior work is complete. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">6</span>
                            <h3>Penetration Firestopping </h3>
                        </div>
                    </div>
                    <p class="mb">Penetration firestopping seals openings in walls or floors to prevent fire and smoke from spreading through penetrations like pipes or cables. It's a crucial safety measure in building construction. This product is installed at the top and bottom of gypsum board fire rated walls. </p>
                    <p>When specified, we install mineral wool insulation and fire-sealant or fire-spray to seal walls to obtain the necessary fire rating per code of compliance drawing(s), deterring smoke/fire from entering areas. </p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">7</span>
                            <h3>Joint Sealants</h3>
                        </div>
                    </div>
                    <p>Joint sealants seal gaps and joints in structures to prevent water, air, or debris from entering, ensuring durability and energy efficiency. Joint sealants can also improve STC (Sound Transmission Class) ratings by reducing sound transfer through walls and floors in a building. This product is installed at the top and bottom of gypsum board STC rated walls.</p>
                </div>
                <div class="card">
                </div>
            </div>
        </div>
    </div>
</div>

<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>